<template>
  <v-tooltip v-if="!edit" bottom>
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        @click.stop="showCommentAside(commentState)"
        small
        class="ml-1"
        :color="countOfComment ? 'error' : 'default'"
      >
        comment
      </v-icon>
    </template>
    <span>Comments({{ countOfComment }})</span>
  </v-tooltip>
</template>

<script>
import Comments from '@/orm/models/Comments';

export default {
  name: 'commentsBadge',
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    commentState: Object,
  },
  inject: ['showCommentAside'],
  computed: {
    countOfComment() {
      return Comments
        .query()
        .where('unique_id', this.commentState.uniqueId)
        .get()
        .length;
    },
  },
};
</script>
